import React, { useEffect, useState } from "react";
import "../Pages/styles/targeting.css"
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import TargetingRenderLayout from "../Components/TargetingComponents/TargetingRenderLayout";
import CustomSelect from "../Components/CustomSelect";
import TargetingSelectOption from "../Components/TargetingComponents/TargetingSelectOption";
import MultipleSelect from "../Components/CustomComponents/MultipleSelect";
import TextInput from "../Components/CustomComponents/TextInput";
import MainButton from "../Components/CustomComponents/MainButton";
import regExp from "../Constants/regExp";
import TargetingSuccessPopup from "../Components/TargetingComponents/TargetingSuccessPopup";
import ChangedConfirmedPopup from "../Components/ChangedConfirmedPopup";
import useBottomPopup from "../Constants/useBottomPopup";
import API from "../api/API";
import { handleCurrentToken } from "../Constants/handleCurrentToken";
import { Loader } from "../Components/Loader";

const firstBlock = {
    "Hotel Inn Code": {
        title: <span style={{ display: 'unset' }}>Hotel Code <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: true,
        error: false,
        errorMessage: 'Fill this label',
        state_type: 'text',
    },
    "Hotel Contact": {
        title: <span style={{ display: 'unset' }}>Hotel Contact <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: true,
        error: false,
        errorMessage: 'Fill this label',
        state_type: 'text',
    },
    "Hotel Contact Email": {
        title: <span style={{ display: 'unset' }}>Hotel Contact Email <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: true,
        error: false,
        errorMessage: 'Fill this label',
        state_type: 'text',
    },
    "Hotel Contact Phone Number": {
        title: <span style={{ display: 'unset' }}>Hotel Contact Phone Number <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: true,
        error: false,
        errorMessage: 'Fill this label',
        field_type: 'phone',
        state_type: 'text',
    },
};

const arrayFields = ['Agriculture', 'Business Services', 'Construction', 'Consumer Services', 'Education', 'Energy & Utilities', 'Finance', 'Government', 'Healthcare Services', 'Hospitals/Physician Clinics ', 'Insurance', 'Legal', 'Manufacturing', 'Media', 'Mining & Minerals', 'Organizations', 'Real Estate', 'Retail', 'Software', 'Telecommunications', 'Transportation', 'Pharmaceuticals', 'Research & Development'];

const cities = ["AK- Anchorage", "AK- Fairbanks", "AL- Anniston", "AL- Birmingham", "AL- Dothan", "AL- Huntsville", "AL- Mobile", "AL- Montgomery", "AL- Tuscaloosa", "AR- Fort Smith", "AR- Jonesboro", "AR- Little Rock", "AZ- Phoenix", "AZ- Tucson", "AZ- Yuma", "CA- Bakersfiled", "CA- Chico", "CA- Eureka", "CA- Fresno", "CA- Irvine", "CA- Los Angeles", "CA- Monterey Bay", "CA- Palm Springs", "CA- Sacramento", "CA- San Diego", "CA- San Francisco", "CA- San Jose", "CA- Santa Barbara", "CO- Colorado Springs", "CO- Denver", "CO- Grand Junction", "CT- Hartford", "DC- Washington", "FL- Fort Myers", "FL- Gainesville", "FL- Jacksonville", "FL- Miami", "FL- Orlando", "FL- Panama City", "FL- Tallahassee", "FL- Tampa Bay", "FL- West Palm Beach", "GA- Albany", "GA- Augusta", "GA- Columbus", "GA- Macon", "GA- Savannah", "HI- Honolulu", "IA- Cedar Rapids", "IA- Davenport", "IA- Des Moines", "IA- Ottumwa", "IA- Sioux City", "ID- Boise City", "ID- Idaho Falls", "ID- Twin Falls", "IL- Chicago", "IL- Peoria", "IL- Quincy", "IL- Rockford", "IL- Springfield", "IN- Evansville", "IN- Fort Wayne", "IN- Indianapolis", "IN- Lafayette", "IN- South Bend", "IN- Terre Haute", "KS- Topeka", "KS- Wichita", "KY- Bowling Green", "KY- Lexington", "KY- Louisville", "KY- Paducah", "LA- Alexandria", "LA- Baton Rouge", "LA- Lafayette", "LA- Lake Charles", "LA- Monroe", "LA- New Orleans", "LA- Shreveport", "MA- Boston", "MA- Springfield", "MD- Baltimore", "MD- Salisbury", "ME- Bangor", "ME- Portland", "ME- Presquelsle", "MI- Alpena", "MI- Detroit", "MI- Flint", "MI- Grand Rapids", "MI- Lansing", "MI- Marquette", "MI- Traverse City", "MN- Duluth", "MN- Mankato", "MN- Minneapolis", "MN- Rochester", "MO- Jefferson City", "MO- Joplin", "MO- Kansas City", "MO- Saint Joseph", "MO- Saint Louis", "MO- Springfield", "MS- Biloxi", "MS- Columbus", "MS- Greenville", "MS- Hattiesburg", "MS- Jackson", "MS- Meridian", "MT- Billings", "MT- Butte", "MT- Glendive", "MT- Great Falls", "MT- Helena", "MT- Missoula", "NC- Charlotte", "NC- Greenville", "NC- Raleigh", "NC- Wilmington", "NC- Winston Salem", "ND- Bismarck", "ND- Fargo", "NE- Lincoln", "NE- North Platte", "NE- Omaha", "NM- Alburquerque", "NV- Las Vegas", "NV- Reno", "NY- Albany", "NY- Binghamton", "NY- Buffalo", "NY- Elmira", "NY- New York", "NY- Rochester", "NY- Syracuse", "NY- Utica", "NY- Watertown", "OH- Cincinnati", "OH- Cleveland", "OH- Dayton", "OH- Lima", "OH- Toledo", "OH- Wheeling", "OH- Youngstown", "OH- Zanesville", "OK- Ardmore", "OK- Oklahoma City", "OK- Tulsa", "OR- Bend", "OR- Eugene", "OR- Medford", "OR- Portland", "PA- Erie", "PA- Harrisburg", "PA- Johnstown", "PA- Philadelphia", "PA- Pittsburgh", "PA- Wilkes Barre", "RI- Providence", "SC- Charleston", "SC- Columbia", "SC- Florence", "SC- Greenville", "SD- Rapid City", "SD- Sioux Falls", "TN- Chattanooga", "TN- Jackson", "TN- Knoxville", "TN- Memphis", "TN- Nashville", "TN- Tri Cities", "TX- Abilene", "TX- Amarillo", "TX- Austin", "TX- Beaumont", "TX- Bryan", "TX- Corpus Christi", "TX- Dallas", "TX- El Paso", "TX- Harlingen", "TX- Houston", "TX- Laredo", "TX- Lubbock", "TX- Odessa", "TX- San Angelo", "TX- San Antonio", "TX- Tyler", "TX- Victoria", "TX- Wichita Falls", "UT- Salt Lake City", "VA- Charlottesville", "VA- Hampton Roads", "VA- Harrisonburg", "VA- Richmond", "VA- Roanoke", "VT- Burlington", "WA- Seattle", "WA- Spokane", "WA- Tri Cities", "WI- Green Bay", "WI- La Crosse", "Wi- Madison", "WI- Milwaukee", "WI- Wausau", "WV- Blue Field", "WV- Charleston", "WV- Clarksburg", "WV- Parkersburg", "WY- Casper", "WY- Cheyenne"];
const secondBlock = {
    "Are you a city-center hotel?": {
        title: <span style={{ display: 'unset' }}>Are you a city-center hotel? <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: true,
        error: false,
        popup: false,
        options: ['yes', 'no'],
        errorMessage: 'Fill this label',
        state_type: 'dropdown',
    },
    "Would you like to specify the zip codes for your backyard?": {
        title: <span style={{ display: 'unset' }}>Would you like to specify the zip codes for your backyard? <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: "Are you a city-center hotel?".value === 'yes',
        double: true,
        error: false,
        popup: false,
        options: ['yes', 'no'],
        errorMessage: 'Fill this label',
        state_type: 'dropdown',
    },
    "How many miles (radius) would you deem encompass your drive market?": {
        title: <span style={{ display: 'unset' }}>How many miles (radius) would you deem encompass your drive market? <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: 'Up to 10 miles',
        required: "Would you like to specify the zip codes for your backyard?".value === 'no',
        error: false,
        double: true,
        options: ['Up to 10 miles', 'Up to 25 miles', 'Up to 50 miles', 'Exact'],
        errorMessage: 'Fill this label',
        state_type: 'radio',
    },
    "What industries are the top industries for your backyard? ( Please select up to 3 )": {
        title: <span style={{ display: 'unset' }}>What industries are the top industries for your backyard? ( Please select up to 3 ) <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        renderTitle: 'What industries are the top industries for your backyard?',
        value: '',
        required: true,
        error: false,
        dataArray: [],
        double: true,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "Please list the zip codes": {
        title: <span style={{ display: 'unset' }}>Please list the zip codes <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        renderTitle: 'Please list the zip codes',
        value: '',
        monoLine: true,
        required: "What industries are the top industries for your backyard? ( Please select up to 3 )".value === 'yes',
        error: false,
        popup: false,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    // "Would you like to select subindustries for your backyard?": {
    //     title: 'Would you like to select subindustries for your backyard?',
    //     value: '',
    //     required: false,
    //     error: false,
    //     popup: false,
    //     options: ['yes', 'no',],
    //     state_type: 'dropdown',
    //     double: true,
    //     errorMessage: 'Fill this label',
    // },
};

const repeatBlock = {
    "What sub-industries would you like for your backyard (agriculture)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(agriculture)</b>?</span>,
        renderTitle: 'Agriculture sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (business services)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(business services)</b>?</span>,
        renderTitle: 'Business services sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (construction)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(construction)</b>?</span>,
        renderTitle: 'Construction sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (consumer services)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(consumer services)</b>?</span>,
        renderTitle: 'Consumer services sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (education)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(education)</b>?</span>,
        renderTitle: 'Education sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (energy & utilities)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(energy & utilities)</b>?</span>,
        renderTitle: 'Energy & utilities sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (finance)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(finance)</b>?</span>,
        renderTitle: 'Finance sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (government)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(government)</b>?</span>,
        renderTitle: 'Government sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (healthcare services)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(healthcare services)</b>?</span>,
        renderTitle: 'Healthcare services sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (hospitals/physician clinics)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(hospitals/physician clinics)</b>?</span>,
        renderTitle: 'Hospitals/physician clinics sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (manufacturing)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(manufacturing)</b>?</span>,
        renderTitle: 'Manufacturing sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (media & internet)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(media & internet)</b>?</span>,
        renderTitle: 'Media & internet sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (organizations)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(organizations)</b>?</span>,
        renderTitle: 'Organizations sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (retail)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(retail)</b>?</span>,
        renderTitle: 'Retail sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (software)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(software)</b>?</span>,
        renderTitle: 'Software sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (telecommunications)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(telecommunications)</b>?</span>,
        renderTitle: 'Telecommunications sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "What sub-industries would you like for your backyard (transportation)?": {
        title: <span
            style={{ display: 'unset' }}>What sub-industries would you like for your backyard <b>(transportation)</b>?</span>,
        renderTitle: 'Transportation sub-industries for backyard?',
        dataArray: [],
        required: false,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
};

const generalRepeatState = {
    "0": repeatBlock,
    "1": repeatBlock,
    "2": repeatBlock,
    "3": repeatBlock,
    "4": repeatBlock,
};

const thirdBlock = {
    "How many miles (radius) would you deem encompass your drive market?": {
        title: 'How many miles (radius) would you deem encompass your drive market?',
        value: 'Up to 10 miles',
        error: false,
        required: true,
        options: ['Up to 10 miles', 'Up to 25 miles', 'Up to 50 miles', 'Exact'],
        errorMessage: 'Fill this label',
        state_type: 'radio',
    },
    "What industries would be the target industries for you drive market? (Please select up to 3)": {
        title: <span
            style={{ display: 'unset' }}>What industries would be the target industries for you drive market? (Please select up to 3) <span
                style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        renderTitle: 'What industries would be the target industries for you drive market? ',
        dataArray: [],
        required: true,
        error: false,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    "Would you like to select subindustries for your drive market?": {
        title: 'Would you like to select subindustries for your drive market?',
        value: '',
        required: false,
        error: false,
        popup: false,
        options: ['yes', 'no',],
        state_type: 'dropdown',
        double: true,
        errorMessage: 'Fill this label',
    },
};

const fourthBlock = {
    "What cities would you include in your feeder market(s)? 1/3": {
        title: <span style={{ display: 'unset' }}>What cities would you include in your feeder market(s)? <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
                style={{ color: '#94A3B8', display: 'unset' }}>1/3</span></span>,
        renderTitle: <span>What cities would you include in your feeder market(s)? <span>1/3</span></span>,
        value: '',
        required: true,
        error: false,
        dataArray: [],
        popup: false,
        options: cities,
        state_type: 'multiselect',
        double: true,
        errorMessage: 'Fill this label',
    },
    "What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 1/3": {
        title: <span style={{ display: 'unset' }}>What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
                style={{ color: '#94A3B8', display: 'unset' }}>1/3</span></span>,
        renderTitle: 'What industries would be the target industries for your feeder market?',
        dataArray: [],
        required: true,
        error: false,
        value: '',
        triple: true,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    // "Would you like to select subindustries for your 1st feeder market?": {
    //     title: 'Would you like to select subindustries for your 1st feeder market?',
    //     value: '',
    //     required: false,
    //     error: false,
    //     popup: false,
    //     options: ['yes', 'no',],
    //     state_type: 'dropdown',
    //     double: true,
    //     errorMessage: 'Fill this label',
    // },
};

const fifthBlock = {
    "What cities would you include in your feeder market(s)? 2/3": {
        title: <span style={{ display: 'unset' }}>What cities would you include in your feeder market(s)? <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
                style={{ color: '#94A3B8', display: 'unset' }}>2/3</span></span>,
        renderTitle: <span>What cities would you include in your feeder market(s)? <span>2/3</span></span>,
        value: '',
        required: true,
        error: false,
        dataArray: [],
        popup: false,
        options: cities,
        state_type: 'multiselect',
        double: true,
        errorMessage: 'Fill this label',
    },
    "What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 2/3": {
        title: <span style={{ display: 'unset' }}>What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
                style={{ color: '#94A3B8', display: 'unset' }}>2/3</span></span>,
        renderTitle: 'What industries would be the target industries for your feeder market?',
        dataArray: [],
        required: true,
        error: false,
        triple: true,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    // "Would you like to select subindustries for your 2nd feeder market?": {
    //     title: 'Would you like to select subindustries for your 2nd feeder market?',
    //     value: '',
    //     required: false,
    //     error: false,
    //     popup: false,
    //     options: ['yes', 'no',],
    //     state_type: 'dropdown',
    //     double: true,
    //     errorMessage: 'Fill this label',
    // },
};

const sixthBlock = {
    "What industries would be the target industries for your feeder market? Please pick up to 3 industries per market.": {
        title:
            <span style={{ display: 'unset' }}>What industries would be the target industries for your feeder market? Please pick up to 3 industries per market. <span
                style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
                    style={{ color: '#94A3B8', display: 'unset' }}>3/3</span></span>,
        dataArray: [],
        required: true,
        error: false,
        triple: true,
        popup: false,
        options: arrayFields,
        errorMessage: 'Fill this label',
        state_type: 'multiselect',
    },
    // "If your market was not listed, please enter it below.": {
    //     title: <span
    //         style={{ display: 'unset' }}>If your market was not listed, please enter it below. <span
    //             style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
    //     renderTitle: 'Market that was not listed',
    //     value: '',
    //     required: "What industries would be the target industries for your feeder market? Please pick up to 3 industries per market.".value === 'yes',
    //     error: false,
    //     errorMessage: 'Fill this label',
    //     state_type: 'text',
    // },
    "What cities would you include in your feeder market(s)? 3/3": {
        title: <span style={{ display: 'unset' }}>What cities would you include in your feeder market(s)? <span
            style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
                style={{ color: '#94A3B8', display: 'unset' }}>3/3</span></span>,
        renderTitle: <span>What cities would you include in your feeder market(s)? <span>3/3</span></span>,
        value: '',
        required: true,
        error: false,
        dataArray: [],
        popup: false,
        options: cities,
        state_type: 'multiselect',
        double: true,
        errorMessage: 'Fill this label',
    },

};

const sevenBlock = {
    // "What cities would you include in your feeder market(s)? 3/3": {
    //     title: <span style={{ display: 'unset' }}>What cities would you include in your feeder market(s)? <span
    //         style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
    //             style={{ color: '#94A3B8', display: 'unset' }}>3/3</span></span>,
    //     renderTitle: <span>What cities would you include in your feeder market(s)? <span>3/3</span></span>,
    //     value: '',
    //     required: true,
    //     error: false,
    //     dataArray: [],
    //     popup: false,
    //     options: arrayFields,
    //     state_type: 'multiselect',
    //     double: true,
    //     errorMessage: 'Fill this label',
    // },
    // "What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 3/3": {
    //     title: <span style={{ display: 'unset' }}>What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. <span
    //         style={{ color: 'var(--error)', display: 'unset' }}>*</span> <span
    //             style={{ color: '#94A3B8', display: 'unset' }}>3/3</span></span>,
    //     renderTitle: 'What industries would be the target industries for your feeder market?',
    //     dataArray: [],
    //     required: true,
    //     error: false,
    //     popup: false,
    //     triple: true,
    //     options: arrayFields,
    //     errorMessage: 'Fill this label',
    //     state_type: 'multiselect',
    // },
    // "Would you like to select subindustries for your 3rd feeder market?": {
    //     title: 'Would you like to select subindustries for your 3rd feeder market?',
    //     value: '',
    //     required: false,
    //     error: false,
    //     popup: false,
    //     options: ['yes', 'no',],
    //     state_type: 'dropdown',
    //     double: true,
    //     errorMessage: 'Fill this label',
    // },
    "Is there a feeder market you wish to add that was not on the list?": {
        title: <span
            style={{ display: 'unset' }}>Is there a feeder market you wish to add that was not on the list?<span
                style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: true,
        error: false,
        popup: false,
        options: ['yes', 'no',],
        state_type: 'dropdown',
        double: true,
        errorMessage: 'Fill this label',
    },
    "If your market was not listed, please enter it below.": {
        title: <span
            style={{ display: 'unset' }}>If your market was not listed, please enter it below.<span
                style={{ color: 'var(--error)', display: 'unset' }}>*</span></span>,
        value: '',
        required: "Is there a feeder market you wish to add that was not on the list?".value === 'yes',
        error: false,
        errorMessage: 'Fill this label',
        state_type: 'text',
    }
};


export default function Targeting() {
    const history = useHistory();
    let { successText, changingConfirmed, changeContinuePopup } = useBottomPopup();
    const store = useSelector(state => state.auth.user_data);

    const [targetingPostData, setTargetingPostData] = useState(null);

    const [repeatData, setRepeatData] = useState(() => generalRepeatState);
    const [firstData, setFirstData] = useState(() => firstBlock);
    const [secondData, setSecondData] = useState(() => secondBlock);
    const [thirdData, setThirdData] = useState(() => thirdBlock);
    const [fourthData, setFourthData] = useState(() => fourthBlock);
    const [fifthData, setFifthData] = useState(() => fifthBlock);
    const [sixthData, setSixthData] = useState(() => sixthBlock);
    const [seventhData, setSeventhData] = useState(() => sevenBlock);
    const [successPopup, setSuccessPopup] = useState(false);

    const [targetingSubmitted, setTargetingSubmitted] = useState({
        targeting_submitted: false,
        data: null,
        loading: false,
    })

    useEffect(() => {
        if (store.role === 'gitgo_admin_main') {
            history.push('/admin/workspaces')
        }
    }, [history, store.role])

    useEffect(() => {
        API(handleCurrentToken()).get(`/targeting/data`)
            .then(res => {
                setTargetingSubmitted({
                    ...res.data,
                    loading: true,
                })
            })
    }, [])

    useEffect(() => {
        setSecondData(prevState => ({
            ...prevState,
            "How many miles (radius) would you deem encompass your drive market?": {
                ...prevState["How many miles (radius) would you deem encompass your drive market?"],
                required: prevState["Are you a city-center hotel?"].value === 'no',
                error: false,
            },
        }))
        //eslint-disable-next-line
    }, [secondData["Are you a city-center hotel?"].value])

    useEffect(() => {
        setSecondData(prevState => ({
            ...prevState,
            "Please list the zip codes": {
                ...prevState["Please list the zip codes"],
                required: prevState["Would you like to specify the zip codes for your backyard?"].value === 'yes',
                error: false,
            },
        }))
        //eslint-disable-next-line
    }, [secondData["Would you like to specify the zip codes for your backyard?"].value])

    useEffect(() => {
        setSixthData(prevState => ({
            ...prevState,
            "If your market was not listed, please enter it below.": {
                ...prevState["If your market was not listed, please enter it below."],
                required: prevState["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].value === 'yes',
                error: false,
            },
        }))
        //eslint-disable-next-line
    }, [sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].value])

    const multiplySelectLayout = (dataObj, optionalLabel, setData, number) => (
        <MultipleSelect
            title={dataObj[number][optionalLabel].title}
            options={dataObj[number][optionalLabel].options}
            popup={dataObj[number][optionalLabel].popup}
            triple={dataObj[number][optionalLabel].triple}
            error={dataObj[number][optionalLabel].error}
            errTitle={dataObj[number][optionalLabel].errorMessage}
            placeholder={dataObj[number][optionalLabel].placeholder ?? null}
            dataArray={dataObj[number][optionalLabel].dataArray}
            handlePopup={() => {
                setData(prevState => ({
                    ...prevState,
                    [number]: {
                        ...prevState[number],
                        [optionalLabel]: {
                            ...prevState[number][optionalLabel],
                            popup: !prevState[number][optionalLabel].popup,
                        }
                    }
                }))
            }}
            disabled={dataObj[number][optionalLabel].dataArray.length > 2}
            setData={(el) => {
                setData(prevState => ({
                    ...prevState,
                    [number]: {
                        ...prevState[number],
                        [optionalLabel]: {
                            ...prevState[number][optionalLabel],
                            dataArray: prevState[number][optionalLabel].dataArray.includes(el) ? prevState[number][optionalLabel].dataArray.filter(item => item !== el) : prevState[number][optionalLabel].dataArray.length === 3 ? prevState[number][optionalLabel].dataArray : [...prevState[number][optionalLabel].dataArray, el],
                            error: false,
                        }
                    }
                }))
            }} />
    )

    const maxThreeOptions = (objData, label, setData) => (
        <MultipleSelect
            title={objData[label].title}
            options={objData[label].options}
            popup={objData[label].popup}
            triple={objData[label].triple}
            error={objData[label].error}
            errTitle={objData[label].errorMessage}
            monoLine={objData[label].monoLine}
            placeholder={objData[label].placeholder ?? null}
            dataArray={objData[label].dataArray}
            handlePopup={() => {
                setData(prevState => ({
                    ...prevState,
                    [label]: {
                        ...prevState[label],
                        popup: !prevState[label].popup,
                    }
                }))
            }}
            disabled={objData[label].dataArray.length > 2}
            setData={(el) => {
                setData(prevState => ({
                    ...prevState,
                    [label]: {
                        ...prevState[label],
                        dataArray: prevState[label].dataArray.includes(el) ? prevState[label].dataArray.filter(item => item !== el) : prevState[label].dataArray.length === 3 ? prevState[label].dataArray : [...prevState[label].dataArray, el],
                        error: false,
                    }
                }))
            }} />
    )

    const repeatSection = (objData, first_label, second_label, setObjData, number) => {
        return [
            <div key={0} className={'fifth_content'}>
                {maxThreeOptions(objData, [first_label], setObjData)}
                {maxThreeOptions(objData, [second_label], setObjData)}
                {/* <CustomSelect
                    className={'targeting_custom_select_wrapper'}
                    title={objData[third_label].title}
                    popupPosition={objData[third_label].double ? '6.25rem' : null}
                    loading={true}
                    options={objData[third_label].options}
                    optionalLabel={[third_label]}
                    svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                            strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round" />
                    </svg>}
                    popup={objData[third_label].popup}
                    setData={e => setObjData(e)}
                    error={objData[third_label].error}
                    placeholder={objData[third_label].placeholder ?? null}
                    errTitle={objData[third_label].errorMessage}
                    value={objData[third_label].value} /> */}
            </div>,

            // objData[third_label].value === 'yes' ?
            //     <div key={1} className={'third_content'}>
            //         {Object.entries(repeatData[0]).map((el, i) => {
            //             return (
            //                 <div key={i}>{multiplySelectLayout(repeatData, [el[0]], setRepeatData, number)}</div>
            //             )
            //         })}
            //     </div> : null
        ]
    }

    const checkValid = (dataObj, setState) => {
        let error = false;
        Object.entries(dataObj).forEach(el => {
            console.log(el[0])
            if (el[1].required) {
                if (el[0] === 'Hotel Contact Email') {
                    if (!regExp.email.test(el[1].value)) {
                        setState(prevState => ({
                            ...prevState,
                            [el[0]]: {
                                ...prevState[el[0]],
                                error: true,
                                errorMessage: 'Wrong email format',
                            }
                        }))
                        error = true
                    }
                }

                if (el[1].dataArray && !el[1].dataArray.length) {
                    setState(prevState => ({
                        ...prevState,
                        [el[0]]: {
                            ...prevState[el[0]],
                            error: true,
                            errorMessage: 'Fill this label',
                        }
                    }))
                    error = true
                } else if (!el[1].dataArray && !el[1].value) {
                    setState(prevState => ({
                        ...prevState,
                        [el[0]]: {
                            ...prevState[el[0]],
                            error: true,
                            errorMessage: 'Fill this label',
                        }
                    }))
                    error = true
                }
            }
        })
        return error
    }

    const handleSubmitTargeting = (e) => {
        e.preventDefault();

        let checkedArray = [
            checkValid(firstData, setFirstData),
            checkValid(secondData, setSecondData),
            checkValid(thirdData, setThirdData),
            checkValid(fourthData, setFourthData),
            checkValid(fifthData, setFifthData),
            checkValid(sixthData, setSixthData),
            // checkValid(seventhData, setSeventhData),
        ]
        let postDataArray;

        postDataArray = [
            { 'Hotel Contact': firstData['Hotel Contact'].value, 'Hotel Contact Email': firstData['Hotel Contact Email'].value, },
            {

                'Hotel Contact Phone Number': firstData['Hotel Contact Phone Number'].value,
            },
            { "line": "" },
        ]

        if (secondData["Are you a city-center hotel?"].value === 'no') {
            postDataArray = [...postDataArray, {
                "Are you a city-center hotel?": secondData["Are you a city-center hotel?"].value,
                "How many miles (radius) would you deem encompass your drive market?": secondData["How many miles (radius) would you deem encompass your drive market?"].value,
                "What industries are the top industries for your backyard?": secondData["What industries are the top industries for your backyard? ( Please select up to 3 )"].dataArray.join('; '),
            }, { "line": "" },]
        } else {
            postDataArray = [...postDataArray, {
                "Are you a city-center hotel?": secondData["Are you a city-center hotel?"].value,
                "How many miles (radius) would you deem encompass your drive market?": secondData["How many miles (radius) would you deem encompass your drive market?"].value,
            }, {
                "Please list the zip codes": secondData["Please list the zip codes"].value,
                "What industries are the top industries for your backyard?": secondData["What industries are the top industries for your backyard? ( Please select up to 3 )"].dataArray.join('; '),
            }, {
                "Would you like to specify the zip codes for your backyard?": secondData["Would you like to specify the zip codes for your backyard?"].value,
            }, { "line": "" },]
        }

        // if (secondData["Would you like to select subindustries for your backyard?"].value === 'yes') {
        //     postDataArray = [...postDataArray, {
        //         "Agriculture sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.join('; ') : '―――',
        //         "Business services sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (business services)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (business services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Construction sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (construction)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (construction)?"].dataArray.join('; ') : '―――',
        //         "Consumer services sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Education sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (education)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (education)?"].dataArray.join('; ') : '―――',
        //         "Energy & utilities sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Finance sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (finance)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (finance)?"].dataArray.join('; ') : '―――',
        //         "Government sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (government)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (government)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Healthcare services sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.join('; ') : '―――',
        //         "Hospitals/physician clinics sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Manufacturing sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.join('; ') : '―――',
        //         "Media & internet sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Organizations sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (organizations)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (organizations)?"].dataArray.join('; ') : '―――',
        //         "Retail sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (retail)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (retail)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Software sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (software)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (software)?"].dataArray.join('; ') : '―――',
        //         "Telecommunications sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.join('; ') : '―――',
        //     },
        //     { "Transportation sub-industries for backyard?": repeatData[0]["What sub-industries would you like for your backyard (transportation)?"].dataArray.length ? repeatData[0]["What sub-industries would you like for your backyard (transportation)?"].dataArray.join('; ') : '―――', },
        //     { "line": "" },]
        // }

        postDataArray = [...postDataArray, {
            'How many miles (radius) would you deem encompass your drive market?': thirdData["How many miles (radius) would you deem encompass your drive market?"].value,
            'What industries would be the target industries for you drive market? ': thirdData["What industries would be the target industries for you drive market? (Please select up to 3)"].dataArray.join('; '),
        }, { 'line': '' }]

        if (thirdData["Would you like to select subindustries for your drive market?"].value === 'yes') {
            postDataArray = [...postDataArray, {
                "Agriculture sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.join('; ') : '―――',
                "Business services sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (business services)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (business services)?"].dataArray.join('; ') : '―――',
            },
            {
                "Construction sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (construction)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (construction)?"].dataArray.join('; ') : '―――',
                "Consumer services sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.join('; ') : '―――',
            },
            {
                "Education sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (education)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (education)?"].dataArray.join('; ') : '―――',
                "Energy & utilities sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.join('; ') : '―――',
            },
            {
                "Finance sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (finance)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (finance)?"].dataArray.join('; ') : '―――',
                "Government sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (government)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (government)?"].dataArray.join('; ') : '―――',
            },
            {
                "Healthcare services sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.join('; ') : '―――',
                "Hospitals/physician clinics sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.join('; ') : '―――',
            },
            {
                "Manufacturing sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.join('; ') : '―――',
                "Media & internet sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.join('; ') : '―――',
            },
            {
                "Organizations sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (organizations)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (organizations)?"].dataArray.join('; ') : '―――',
                "Retail sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (retail)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (retail)?"].dataArray.join('; ') : '―――',
            },
            {
                "Software sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (software)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (software)?"].dataArray.join('; ') : '―――',
                "Telecommunications sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.join('; ') : '―――',
            },
            { "Transportation sub-industries for backyard?": repeatData[1]["What sub-industries would you like for your backyard (transportation)?"].dataArray.length ? repeatData[1]["What sub-industries would you like for your backyard (transportation)?"].dataArray.join('; ') : '―――', },
            { "line": "" },]
        }

        postDataArray = [...postDataArray, {
            'What cities would you include in your feeder market(s)? 1/3': fourthData["What cities would you include in your feeder market(s)? 1/3"].dataArray.join('; '),
            'What industries would be the target industries for your feeder market?': fourthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 1/3"].dataArray.join('; ')
        }, { "line": "" },]

        // if (fourthData["Would you like to select subindustries for your 1st feeder market?"].value === 'yes') {
        //     postDataArray = [...postDataArray, {
        //         "Agriculture sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.join('; ') : '―――',
        //         "Business services sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (business services)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (business services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Construction sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (construction)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (construction)?"].dataArray.join('; ') : '―――',
        //         "Consumer services sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Education sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (education)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (education)?"].dataArray.join('; ') : '―――',
        //         "Energy & utilities sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Finance sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (finance)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (finance)?"].dataArray.join('; ') : '―――',
        //         "Government sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (government)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (government)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Healthcare services sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.join('; ') : '―――',
        //         "Hospitals/physician clinics sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Manufacturing sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.join('; ') : '―――',
        //         "Media & internet sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Organizations sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (organizations)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (organizations)?"].dataArray.join('; ') : '―――',
        //         "Retail sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (retail)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (retail)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Software sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (software)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (software)?"].dataArray.join('; ') : '―――',
        //         "Telecommunications sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.join('; ') : '―――',
        //     },
        //     { "Transportation sub-industries for backyard?": repeatData[2]["What sub-industries would you like for your backyard (transportation)?"].dataArray.length ? repeatData[2]["What sub-industries would you like for your backyard (transportation)?"].dataArray.join('; ') : '―――', },
        //     { "line": "" },]
        // }

        postDataArray = [...postDataArray, {
            'What cities would you include in your feeder market(s)? 2/3': fifthData["What cities would you include in your feeder market(s)? 2/3"].dataArray.join('; '),
            'What industries would be the target industries for your feeder market?': fifthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 2/3"].dataArray.join('; ')
        }, { "line": "" },]

        // if (fifthData["Would you like to select subindustries for your 2nd feeder market?"].value === 'yes') {
        //     postDataArray = [...postDataArray, {
        //         "Agriculture sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.join('; ') : '―――',
        //         "Business services sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (business services)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (business services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Construction sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (construction)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (construction)?"].dataArray.join('; ') : '―――',
        //         "Consumer services sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Education sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (education)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (education)?"].dataArray.join('; ') : '―――',
        //         "Energy & utilities sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Finance sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (finance)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (finance)?"].dataArray.join('; ') : '―――',
        //         "Government sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (government)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (government)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Healthcare services sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.join('; ') : '―――',
        //         "Hospitals/physician clinics sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Manufacturing sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.join('; ') : '―――',
        //         "Media & internet sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Organizations sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (organizations)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (organizations)?"].dataArray.join('; ') : '―――',
        //         "Retail sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (retail)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (retail)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Software sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (software)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (software)?"].dataArray.join('; ') : '―――',
        //         "Telecommunications sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.join('; ') : '―――',
        //     },
        //     { "Transportation sub-industries for backyard?": repeatData[3]["What sub-industries would you like for your backyard (transportation)?"].dataArray.length ? repeatData[3]["What sub-industries would you like for your backyard (transportation)?"].dataArray.join('; ') : '―――', },
        //     { "line": "" },]
        // }

        postDataArray = [...postDataArray, {
            'What cities would you include in your feeder market(s)? 3/3': sixthData["What cities would you include in your feeder market(s)? 3/3"].dataArray.join('; '),
            'What industries would be the target industries for your feeder market? Please pick up to 3 industries per market.': sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].dataArray.join('; ')
        }, { "line": "" },]


        if (seventhData["Is there a feeder market you wish to add that was not on the list?"].value === 'yes') {
            postDataArray = [...postDataArray, {
                'Is there a feeder market you wish to add that was not on the list?': seventhData["Is there a feeder market you wish to add that was not on the list?"].value,
                'If your market was not listed, please enter it below.': seventhData["If your market was not listed, please enter it below."].value
            }, { "line": "" },]
        } else {
            postDataArray = [...postDataArray, {
                'Is there a feeder market you wish to add that was not on the list?': seventhData["Is there a feeder market you wish to add that was not on the list?"].value,
            }, { "line": "" },]
        }
        // if (seventhData["Would you like to select subindustries for your 3rd feeder market?"].value === 'yes') {
        //     postDataArray = [...postDataArray, {
        //         "Agriculture sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (agriculture)?"].dataArray.join('; ') : '―――',
        //         "Business services sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (business services)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (business services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Construction sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (construction)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (construction)?"].dataArray.join('; ') : '―――',
        //         "Consumer services sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (consumer services)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Education sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (education)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (education)?"].dataArray.join('; ') : '―――',
        //         "Energy & utilities sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (energy & utilities)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Finance sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (finance)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (finance)?"].dataArray.join('; ') : '―――',
        //         "Government sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (government)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (government)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Healthcare services sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (healthcare services)?"].dataArray.join('; ') : '―――',
        //         "Hospitals/physician clinics sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (hospitals/physician clinics)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Manufacturing sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (manufacturing)?"].dataArray.join('; ') : '―――',
        //         "Media & internet sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (media & internet)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Organizations sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (organizations)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (organizations)?"].dataArray.join('; ') : '―――',
        //         "Retail sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (retail)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (retail)?"].dataArray.join('; ') : '―――',
        //     },
        //     {
        //         "Software sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (software)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (software)?"].dataArray.join('; ') : '―――',
        //         "Telecommunications sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (telecommunications)?"].dataArray.join('; ') : '―――',
        //     },
        //     { "Transportation sub-industries for backyard?": repeatData[4]["What sub-industries would you like for your backyard (transportation)?"].dataArray.length ? repeatData[4]["What sub-industries would you like for your backyard (transportation)?"].dataArray.join('; ') : '―――', },
        //     { "line": "" },]
        // }


        if (checkedArray.filter(Boolean).length) {
            document.getElementById('error_scroll').scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            })
        } else {
            API(handleCurrentToken()).post(`/targeting/data`, {
                data: postDataArray
            })
                .then(res => {
                    if (res.status === 200) {
                        setTargetingPostData(postDataArray)
                        setSuccessPopup(true)
                    }
                })
        }
    }

    return [
        <ChangedConfirmedPopup successText={successText}
            key={0}
            changingConfirmed={changingConfirmed} />,
        <div style={!targetingSubmitted.loading ? {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        } : null} key={1} className={'targeting_wrapper'}>
            {targetingSubmitted.loading
                ? targetingSubmitted.targeting_submitted ?
                    <TargetingSuccessPopup setSuccessPopup={e => setSuccessPopup(e)}
                        repeatData={repeatData}
                        className={'data_submitted'}
                        firstData={firstData}
                        targetingSubmitted={targetingSubmitted}
                        secondData={secondData}
                        setTargetingSubmitted={e => setTargetingSubmitted(e)}
                        thirdData={thirdData}
                        changeContinuePopup={changeContinuePopup}
                        fourthData={fourthData}
                        fifthData={fifthData}
                        sixthData={sixthData}
                        seventhData={seventhData} />
                    : <form id={'error_scroll'}
                        onSubmit={(e) => handleSubmitTargeting(e)}>
                        <h2 className={'page_title'}>Fuel Your Sales Effort and Order More Prospect Data</h2>
                        <p style={{fontWeight: '600'}}>This form is to send the prospect criteria for purchasing more data</p>
                        <p className={'subtitle'}>Please note this form can only be accepted one time per hotel. If
                            there
                            are
                            questions please reach out prior to submitting.</p>
                        <div className={'first_content'}>
                            <TargetingRenderLayout objectData={firstData} setObjectData={e => setFirstData(e)} />
                        </div>
                        <div className={'second_content'}>
                            {secondData["Are you a city-center hotel?"].value === 'yes'
                                ? <div className={'inline_gap'}>
                                    <div className={'horizontal_gap'}>
                                        <CustomSelect title={secondData["Are you a city-center hotel?"].title}
                                            loading={true}
                                            className={'targeting_custom_select_wrapper'}
                                            options={secondData["Are you a city-center hotel?"].options}
                                            optionalLabel={["Are you a city-center hotel?"]}
                                            svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                                    strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>}
                                            popup={secondData["Are you a city-center hotel?"].popup}
                                            setData={e => setSecondData(e)}
                                            error={secondData["Are you a city-center hotel?"].error}
                                            placeholder={secondData["Are you a city-center hotel?"].placeholder ?? null}
                                            errTitle={secondData["Are you a city-center hotel?"].errorMessage}
                                            value={secondData["Are you a city-center hotel?"].value} />
                                        <CustomSelect
                                            title={secondData["Would you like to specify the zip codes for your backyard?"].title}
                                            loading={true}
                                            className={'targeting_custom_select_wrapper'}
                                            options={secondData["Would you like to specify the zip codes for your backyard?"].options}
                                            optionalLabel={["Would you like to specify the zip codes for your backyard?"]}
                                            svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                                    strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>}
                                            popupPosition={secondData["Would you like to specify the zip codes for your backyard?"].double ? '6.25rem' : null}
                                            popup={secondData["Would you like to specify the zip codes for your backyard?"].popup}
                                            setData={e => setSecondData(e)}
                                            error={secondData["Would you like to specify the zip codes for your backyard?"].error}
                                            placeholder={secondData["Would you like to specify the zip codes for your backyard?"].placeholder ?? null}
                                            errTitle={secondData["Would you like to specify the zip codes for your backyard?"].errorMessage}
                                            value={secondData["Would you like to specify the zip codes for your backyard?"].value} />
                                    </div>
                                    <div className={'horizontal_gap'}>

                                        {maxThreeOptions(secondData, "What industries are the top industries for your backyard? ( Please select up to 3 )", setSecondData)}

                                        {secondData["Would you like to specify the zip codes for your backyard?"].value === 'yes' ? <TextInput value={secondData["Please list the zip codes"].value}
                                            type={'text'}
                                            title={secondData["Please list the zip codes"].title}
                                            key={secondData["Please list the zip codes"]}
                                            targetingInput
                                            onChange={({ target }) => {
                                                setSecondData(prevState => ({
                                                    ...prevState,
                                                    "Please list the zip codes": {
                                                        ...prevState["Please list the zip codes"],
                                                        value: target.value,
                                                        error: false,
                                                    }
                                                }))
                                            }}

                                        /> : <div>
                                            <TargetingSelectOption
                                                title={secondData["How many miles (radius) would you deem encompass your drive market?"].title}
                                                value={secondData["How many miles (radius) would you deem encompass your drive market?"].value}
                                                label={"How many miles (radius) would you deem encompass your drive market?"}
                                                options={secondData["How many miles (radius) would you deem encompass your drive market?"].options}
                                                setData={(e) => setSecondData(e)} />
                                        </div>}
                                        {/* {secondData["Would you like to specify the zip codes for your backyard?"].value === 'yes' ?
                                            maxThreeOptions(secondData, "Please list the zip codes", setSecondData) : null} */}
                                    </div>
                                    {/* <div className={'horizontal_gap'}>
                                        <CustomSelect
                                            title={secondData["Would you like to select subindustries for your backyard?"].title}
                                            className={'targeting_custom_select_wrapper'}
                                            popupPosition={secondData["Would you like to select subindustries for your backyard?"].double ? '6.25rem' : null}
                                            loading={true}
                                            options={secondData["Would you like to select subindustries for your backyard?"].options}
                                            optionalLabel={["Would you like to select subindustries for your backyard?"]}
                                            svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                                    strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>}

                                            popup={secondData["Would you like to select subindustries for your backyard?"].popup}
                                            setData={e => setSecondData(e)}
                                            error={secondData["Would you like to select subindustries for your backyard?"].error}
                                            placeholder={secondData["Would you like to select subindustries for your backyard?"].placeholder ?? null}
                                            errTitle={secondData["Would you like to select subindustries for your backyard?"].errorMessage}
                                            value={secondData["Would you like to select subindustries for your backyard?"].value} />
                                    </div> */}
                                </div>
                                : <div className={'inline'}>
                                    <div className={'vertical_gap'}>
                                        <CustomSelect title={secondData["Are you a city-center hotel?"].title}
                                            loading={true}
                                            className={'targeting_custom_select_wrapper'}
                                            options={secondData["Are you a city-center hotel?"].options}
                                            optionalLabel={["Are you a city-center hotel?"]}
                                            svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                                    strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>}
                                            popup={secondData["Are you a city-center hotel?"].popup}
                                            setData={e => setSecondData(e)}
                                            error={secondData["Are you a city-center hotel?"].error}
                                            placeholder={secondData["Are you a city-center hotel?"].placeholder ?? null}
                                            errTitle={secondData["Are you a city-center hotel?"].errorMessage}
                                            value={secondData["Are you a city-center hotel?"].value} />

                                        {maxThreeOptions(secondData, "What industries are the top industries for your backyard? ( Please select up to 3 )", setSecondData)}

                                        {/* <CustomSelect
                                            className={'targeting_custom_select_wrapper'}
                                            title={secondData["Would you like to select subindustries for your backyard?"].title}
                                            popupPosition={secondData["Would you like to select subindustries for your backyard?"].double ? '6.25rem' : null}
                                            loading={true}
                                            options={secondData["Would you like to select subindustries for your backyard?"].options}
                                            optionalLabel={["Would you like to select subindustries for your backyard?"]}
                                            svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                                    strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>}

                                            popup={secondData["Would you like to select subindustries for your backyard?"].popup}
                                            setData={e => setSecondData(e)}
                                            error={secondData["Would you like to select subindustries for your backyard?"].error}
                                            placeholder={secondData["Would you like to select subindustries for your backyard?"].placeholder ?? null}
                                            errTitle={secondData["Would you like to select subindustries for your backyard?"].errorMessage}
                                            value={secondData["Would you like to select subindustries for your backyard?"].value} /> */}
                                    </div>
                                    <div>
                                        <TargetingSelectOption
                                            title={secondData["How many miles (radius) would you deem encompass your drive market?"].title}
                                            value={secondData["How many miles (radius) would you deem encompass your drive market?"].value}
                                            label={"How many miles (radius) would you deem encompass your drive market?"}
                                            options={secondData["How many miles (radius) would you deem encompass your drive market?"].options}
                                            setData={(e) => setSecondData(e)} />
                                    </div>
                                </div>}
                        </div>
                        {/* {secondData["Would you like to select subindustries for your backyard?"].value === 'yes' ?
                            <div className={'third_content'}>
                                {Object.entries(repeatData[0]).map((el, i) => {
                                    return (
                                        <div
                                            key={i}>{multiplySelectLayout(repeatData, [el[0]], setRepeatData, '0')}</div>
                                    )
                                })}
                            </div> : null} */}
                        <div className={'fourth_content'}>
                            <TargetingSelectOption
                                title={thirdData["How many miles (radius) would you deem encompass your drive market?"].title}
                                value={thirdData["How many miles (radius) would you deem encompass your drive market?"].value}
                                label={"How many miles (radius) would you deem encompass your drive market?"}
                                options={thirdData["How many miles (radius) would you deem encompass your drive market?"].options}
                                setData={(e) => setThirdData(e)} />
                            {maxThreeOptions(thirdData, "What industries would be the target industries for you drive market? (Please select up to 3)", setThirdData)}
                            {/* <CustomSelect
                                className={'targeting_custom_select_wrapper'}
                                title={thirdData["Would you like to select subindustries for your drive market?"].title}
                                popupPosition={thirdData["Would you like to select subindustries for your drive market?"].double ? '6.25rem' : null}
                                loading={true}
                                options={thirdData["Would you like to select subindustries for your drive market?"].options}
                                optionalLabel={["Would you like to select subindustries for your drive market?"]}
                                svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                        strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round" />
                                </svg>}
                                popup={thirdData["Would you like to select subindustries for your drive market?"].popup}
                                setData={e => setThirdData(e)}
                                error={thirdData["Would you like to select subindustries for your drive market?"].error}
                                placeholder={thirdData["Would you like to select subindustries for your drive market?"].placeholder ?? null}
                                errTitle={thirdData["Would you like to select subindustries for your drive market?"].errorMessage}
                                value={thirdData["Would you like to select subindustries for your drive market?"].value} /> */}
                        </div>

                        {thirdData["Would you like to select subindustries for your drive market?"].value === 'yes' ?
                            <div className={'third_content'}>
                                {Object.entries(repeatData[0]).map((el, i) => {
                                    return (
                                        <div
                                            key={i}>{multiplySelectLayout(repeatData, [el[0]], setRepeatData, '1')}</div>
                                    )
                                })}
                            </div> : null}

                        {repeatSection(fourthData, "What cities would you include in your feeder market(s)? 1/3", "What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 1/3", setFourthData, '2')}

                        {repeatSection(fifthData, "What cities would you include in your feeder market(s)? 2/3", "What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 2/3", setFifthData, '3')}
                        {repeatSection(sixthData, "What cities would you include in your feeder market(s)? 3/3", "What industries would be the target industries for your feeder market? Please pick up to 3 industries per market.", setSixthData, '2')}

                        {/* {maxThreeOptions(sixthData, "What industries would be the target industries for your feeder market? Please pick up to 3 industries per market.", setSixthData)}
                            <CustomSelect
                                className={'targeting_custom_select_wrapper'}
                                title={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].title}
                                popupPosition={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].double ? '6.25rem' : null}
                                loading={true}
                                options={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].options}
                                optionalLabel={["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."]}
                                svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                        strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round" />
                                </svg>}
                                popup={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].popup}
                                setData={e => setSixthData(e)}
                                error={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].error}
                                placeholder={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].placeholder ?? null}
                                errTitle={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].errorMessage}
                                value={sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].value} /> */}

                        {sixthData["What industries would be the target industries for your feeder market? Please pick up to 3 industries per market."].value === 'yes' ?
                            <TextInput
                                value={sixthData["If your market was not listed, please enter it below."].value}
                                title={sixthData["If your market was not listed, please enter it below."].title}
                                key={sixthData["If your market was not listed, please enter it below."].title}
                                targetingInput
                                wrapper_margin={sixthData["If your market was not listed, please enter it below."].full_line ? 'full_line' : null}
                                maxLength={sixthData["If your market was not listed, please enter it below."].max_length}
                                placeholder={sixthData["If your market was not listed, please enter it below."].placeholder}
                                error={sixthData["If your market was not listed, please enter it below."].error}
                                errTitle={sixthData["If your market was not listed, please enter it below."].errorMessage}
                                onChange={({ target }) => {
                                    setSixthData(prevState => ({
                                        ...prevState,
                                        "If your market was not listed, please enter it below.": {
                                            ...prevState["If your market was not listed, please enter it below."],
                                            value: target.value,
                                            error: false,
                                        }
                                    }))
                                }} /> : null}

                        <div className={'sixth_content'}>
                            <CustomSelect
                                title={seventhData["Is there a feeder market you wish to add that was not on the list?"].title}
                                className={'targeting_custom_select_wrapper'}
                                popupPosition={seventhData["Is there a feeder market you wish to add that was not on the list?"].double ? '6.25rem' : null}
                                loading={true}
                                options={seventhData["Is there a feeder market you wish to add that was not on the list?"].options}
                                optionalLabel={["Is there a feeder market you wish to add that was not on the list?"]}
                                svg={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 10L12 14L16 10H8Z" fill="#0F172A" stroke="#0F172A"
                                        strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round" />
                                </svg>}

                                popup={seventhData["Is there a feeder market you wish to add that was not on the list?"].popup}
                                setData={e => setSeventhData(e)}
                                error={seventhData["Is there a feeder market you wish to add that was not on the list?"].error}
                                placeholder={seventhData["Is there a feeder market you wish to add that was not on the list?"].placeholder ?? null}
                                errTitle={seventhData["Is there a feeder market you wish to add that was not on the list?"].errorMessage}
                                value={seventhData["Is there a feeder market you wish to add that was not on the list?"].value} />
                            {seventhData["Is there a feeder market you wish to add that was not on the list?"].value === 'yes' &&
                                <TextInput value={seventhData["If your market was not listed, please enter it below."].value}
                                    type={'text'}
                                    title={seventhData["If your market was not listed, please enter it below."].title}
                                    key={seventhData["If your market was not listed, please enter it below."]}
                                    targetingInput
                                    error={seventhData["If your market was not listed, please enter it below."].error}
                                    errTitle={seventhData["If your market was not listed, please enter it below."].errorMessage}
                                    onChange={({ target }) => {
                                        setSeventhData(prevState => ({
                                            ...prevState,
                                            "If your market was not listed, please enter it below.": {
                                                ...prevState["If your market was not listed, please enter it below."],
                                                value: target.value,
                                                error: false,
                                            }
                                        }))
                                    }}

                                />}

                            {/* {repeatSection(seventhData, "What cities would you include in your feeder market(s)? 3/3", "What industries would be the target industries for your feeder market? Please pick up to 3 industries over market. 3/3", "Would you like to select subindustries for your 3rd feeder market?", setSeventhData, '4')} */}
                        </div>
                        <div className={'button_wrap'}>
                            <MainButton type={'submit'}
                                text={'Submit'}
                                className={'submit_button'}
                            />
                        </div>
                    </form> : <Loader color={{
                        '--bgColor': 'var(--gitgo-blue)',
                        '--size': '40px',
                        '--wrapper_size': '40px'
                    }} />}</div>,
        successPopup ? <TargetingSuccessPopup key={2}
            setSuccessPopup={e => setSuccessPopup(e)}
            repeatData={repeatData}
            firstData={firstData}
            postDataArray={targetingPostData}
            secondData={secondData}
            setTargetingSubmitted={e => setTargetingSubmitted(e)}
            thirdData={thirdData}
            targetingSubmitted={targetingSubmitted}
            changeContinuePopup={changeContinuePopup}
            fourthData={fourthData}
            fifthData={fifthData}
            sixthData={sixthData}
            seventhData={seventhData} /> : null,
    ]
}